<template lang="html" src="./road-path.html"></template>
<style lang="scss" scoped src="./road-path.scss"></style>

<script>
export default {
  name: "RoadPath"
};
</script>
